import React from 'react';
import { withFullHydrate } from '@ecommerce/nest-ssr/common';
import StaticPageLayoutMobile from 'layouts/static-page-layout/static-page-layout.mobile';
import DigitalServicesActBase from 'modules/static-pages/digital-services-act/pages/digital-services-act.base';
import { ActiveRecipientsInterface } from 'modules/static-pages/digital-services-act/digital-services-act.controller';

const DigitalServicesActMobile: React.FC<{ activeRecipients: ActiveRecipientsInterface; }> = ({ activeRecipients }) => (
    <StaticPageLayoutMobile>
        <DigitalServicesActBase activeRecipients={activeRecipients} />
    </StaticPageLayoutMobile>
);

export default withFullHydrate(DigitalServicesActMobile, { root: '#root' }, 'modules/static-pages/digital-services-act/pages/digital-services-act.mobile');
